<!-- .block-slideshow -->
<div class="block-slideshow" [lang]="translate.currentLang">
    <div class="flex flex-row gap-2">
        <div class="to-tablet:hidden" *ngIf="withDepartments"><app-sectors-menu></app-sectors-menu></div>
        <div class="block-slideshow__body min-w-0 flex-auto">
            <owl-carousel-o *ngIf="slides?.length" [options]="options" appOwlPreventClick>
                <ng-container *ngFor="let slide of slides">
                    <ng-template carouselSlide
                        *ngIf="slide.desktopImage?.[translate.currentLang]?.url || slide.mobileImage?.[translate.currentLang]?.url">
                        <div class="block-slideshow__slide"  
                            [style.background-color]="slide?.colors?.background ? slide?.colors?.background : 'white'">
                            <ng-container *ngTemplateOutlet="slideTemp; context: { slide : slide }"></ng-container>
                        </div>
                    </ng-template>
                </ng-container>

            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- .block-slideshow / end -->

<ng-template #slideTemp let-slide="slide">
    <div class="block-slideshow__slide-image block-slideshow__slide-image--desktop">
        <img [src]="slide.desktopImage?.[translate.currentLang]?.url"
            [alt]="'slider-'+(translationHelper.localize(slide?.title)?? '')" />
    </div>
    <div class="block-slideshow__slide-image block-slideshow__slide-image--mobile">
        <img [src]="slide.mobileImage?.[translate.currentLang]?.url"
            [alt]="'slider-'+(translationHelper.localize(slide?.title)?? '')" />
    </div>
    <div class="block-slideshow__slide-container flex flex-col">
        <div class="block-slideshow__slide-title"
            [style.color]="slide?.colors?.titleColor ? slide?.colors?.titleColor : null"
            [innerHTML]="sanitizer.bypassSecurityTrustHtml(translationHelper.localize(slide?.title))">
        </div>
        <div class="block-slideshow__slide-text"
            [style.color]="slide?.colors?.textColor ? slide?.colors?.textColor : null"
            [innerHTML]="sanitizer.bypassSecurityTrustHtml(translationHelper.localize(slide?.text))">
        </div>
        <div class="block-slideshow__slide-button w-20 mt-auto" *ngIf="slide.url">
            <a [routerLink]="['/'+translate.currentLang+'/'+slide.url]" *ngIf="slide.externalLink =='false'">
                <span class="btn btn-primary btn-lg">
                    <img
                        [src]="isRTL?'assets/svg/banner/banner_arrow_left.svg':'assets/svg/banner/banner_arrow_right.svg'">
                </span>
            </a>
            <a [href]="slide.url" *ngIf="slide.externalLink =='true'">
                <span class="btn btn-primary btn-lg">
                    <img
                        [src]="isRTL?'assets/svg/banner/banner_arrow_left.svg':'assets/svg/banner/banner_arrow_right.svg'">
                </span>
            </a>
        </div>
    </div>
</ng-template>